import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-float-button',
  templateUrl: './float-button.component.html',
  styleUrls: ['./float-button.component.css']
})
export class FloatButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    const trigger = document.querySelector('#floatingButton');
const container = document.querySelector('#floatingMenu');

trigger.addEventListener('click', () => {

  trigger.classList.toggle('active');
})
  }

}
